import React, { ReactNode } from 'react';
import { HorizontalListStyled } from './HorizontalList.styles';

interface Props {
  padding: number;
  maxLength?: number;
  isScrollable?: boolean;
  children: ReactNode;
  paddingBottom?: number;
  'data-testid'?: string;
}

export const HorizontalList = (props: Props) => (
  <HorizontalListStyled
    {...props}
    length={React.Children.count(props.children)}
  >
    {props.children}
  </HorizontalListStyled>
);
